import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { FieldState } from 'formstate';
import Form from 'react-bootstrap/Form';
import { InputGroup } from 'react-bootstrap';
import { YlFormGroup } from './YlFormGroup';  
import 'react-intl-tel-input/dist/main.css';
import 'libphonenumber-js-utils';
import './YlPhoneInput.scss';
import { IntlPhoneInput } from '../../app/customer-information/phone/IntlPhoneInput';

export interface YlPhoneInputProps {
  field: FieldState<any>;
  type?: string;
  label: string;
  id?: string;
  required?: boolean;
  customAttributes?: { [key: string]: any };
  size?: number;
  disabled?: boolean;
  helpLabel?: string;
  onChange?: (value: string | number) => void;
  inputPrefix?: string;
  internationalMode?: boolean;
  defaultCountryIsoCode?: string;
}

export const YlPhoneInput: FC<YlPhoneInputProps> = observer(function YlPhoneInput({
  field,
  label,
  id,
  type,
  required,
  size,
  helpLabel,
  customAttributes = {},
  disabled = false,
  onChange,
  inputPrefix,
  internationalMode,
  defaultCountryIsoCode
}) {
  function triggerChange(value: any) {
    field.onChange(value);
    if (onChange) {
      onChange(value);
    }
  }
  return (
    <YlFormGroup {...{ field, label, id, required, size, helpLabel }}>
      {internationalMode ? (
         <IntlPhoneInput
          id={id}
          required={required} 
          value={field.value}
          onChange={triggerChange}
          onBlur={field.enableAutoValidationAndValidate}
          disabled={disabled}
          defaultCountry={defaultCountryIsoCode}
          preferredCountries={defaultCountryIsoCode ? [defaultCountryIsoCode.toLowerCase()] : undefined}
          style={{ width: '100%' }}
           ></IntlPhoneInput> 
      ) : (
        <InputGroup>
          {inputPrefix && (
            <InputGroup.Prepend>
              <InputGroup.Text>{inputPrefix}</InputGroup.Text>
            </InputGroup.Prepend>
          )}
          <Form.Control
            as="input"
            required={required}
            type={type || 'text'}
            value={field.value}
            onChange={(e: any) => triggerChange(e.target.value)}
            isInvalid={field.hasError}
            onBlur={field.enableAutoValidationAndValidate}
            disabled={disabled}
            {...customAttributes}
          />
        </InputGroup>
      )}
    </YlFormGroup>
  );
});
